<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<!-- Header -->
<div class="cssLayoutRowStartCenter">
  <div class="sp-icon" style="margin-right: 10px;">
    <mat-icon class="mdi-24px" fontIcon="mdi-playlist-play" [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
  </div>
  <mat-form-field class="button-margins">
    <mat-label>Evaluation</mat-label>
    <mat-select placeholder="Evaluation" [value]="selectedEvaluation.id"
      (selectionChange)="selectEvaluation($event.value)">
      @for (evaluation of evaluationList; track evaluation) {
      <mat-option [value]="evaluation.id">
        {{ evaluation.description }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="button-margins">
    <mat-label>Types</mat-label>
    <mat-select placeholder="Types" [(ngModel)]="selectedSubmissionTypes" multiple
      (selectionChange)="criteriaChanged()">
      @for (submissionType of submissionTypes; track submissionType) {
      <mat-option [value]="submissionType">{{ submissionType
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="button-margins">
    <mat-label>Move</mat-label>
    <mat-select placeholder="Move" [value]="selectedMove" (selectionChange)="selectMove($event.value)">
      <mat-option [value]="-1">All Moves</mat-option>
      @for (move of moveList; track move) {
      <mat-option [value]="move">
        {{ move }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div>
    <mat-paginator #paginator [length]="filteredSubmission.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]" (page)="paginatorEvent($event)"></mat-paginator>
  </div>
</div>

<!-- Table -->
<div class="table-container elevate">
  <table mat-table [dataSource]="displayedSubmissions" matSort (matSortChange)="sortChanged($event)">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><span style="margin-left: 80px;">Name</span></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button ngxClipboard [cbContent]="row.id" (click)="$event.stopPropagation()"
          title="Copy Submission ID to clipboard:  {{ row.id }}">
          <mat-icon class="mdi-18px" fontIcon="mdi-content-copy">
          </mat-icon>
        </button>
        <button mat-icon-button class="button-end" (click)="deleteSubmissionRequest(row); $event.stopPropagation()"
          title="Delete Submission">
          <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"></mat-icon>
        </button>
        {{ row.name }}
      </td>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="submissionType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let row">{{ row.submissionType }}</td>
    </ng-container>

    <!-- Move Column -->
    <ng-container matColumnDef="moveNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Move</th>
      <td mat-cell *matCellDef="let row">{{ row.moveNumber }}</td>
    </ng-container>

    <!-- Score Column -->
    <ng-container matColumnDef="score">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Score</th>
      <td mat-cell *matCellDef="let row">{{ row.score | number: '1.0-2' }}</td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let row">{{ row.status }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data matching the filter</td>
    </tr>
  </table>
</div>

<!-- Loading Indicator -->
@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
